var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-legend"},_vm._l((_vm.items),function(item){return _c('div',{key:item.legendLabel,staticClass:"legend-item"},[_c('div',{staticClass:"item-color",style:({
				backgroundColor: item.color
			})}),_vm._v(" "+_vm._s(item.legendLabel)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }